import { ApiModelProperty } from '@nestjs/swagger/dist/decorators/api-model-property.decorator';
import { IsNotEmpty, IsString,  IsOptional } from 'class-validator';

export class AccountAccreditationRequestDto {
    @ApiModelProperty({
        type: 'string',
        description: 'Note including the type of the document provided by the investor',
    })
    @IsString()
    @IsOptional()
    note?: string;
}
